import React from 'react';
import { CheckIcon, CreditCardIcon, LockIcon, MailIcon } from 'lucide-react';
import { Eyebrow } from './ui/Eyebrow';
import { CtaButton } from './ui/CtaButton';
import { CountdownClock } from './CountdownClock';
import { offerIncludes } from '../data/content';
export function OfferSection() {
  return <section id="comprar" className="border-b border-line bg-cream" data-id="element-137" data-mp="def0n3rwzhwa">
      <div className="mx-auto max-w-6xl px-5 py-20 lg:py-24" data-id="element-138" data-mp="id89uk064mqn">
        <div className="grid gap-12 lg:grid-cols-[0.95fr_1.05fr] lg:gap-16" data-id="element-139" data-mp="icylf0urunn2">
          <div data-id="element-140" data-mp="mdiglyvsbh6k">
            <Eyebrow data-id="element-141" data-mp="md0c6eyyxwnk">Oferta por tiempo limitado</Eyebrow>
            <h2 className="mt-4 font-display text-3xl font-semibold leading-tight text-ink sm:text-4xl" data-id="element-142" data-mp="rdej1tou30k0">
              La promo de 60% off vence en
            </h2>
            <p className="mt-4 max-w-prose text-[15px] leading-relaxed text-ink-soft" data-id="element-143" data-mp="wan4q496xmq0">
              Este precio termina esta noche. Después, el pack vuelve a su precio habitual.
            </p>

            <div className="mt-8" data-id="element-144" data-mp="2y67bqikd5t25">
              <CountdownClock data-id="element-145" data-mp="12o1rms1ygi2r" />
            </div>

            <div className="mt-10 max-w-md" data-id="element-146" data-mp="12otijpklxrmp">
              <div className="flex items-baseline justify-between text-[11px] font-semibold uppercase tracking-eyebrow" data-id="element-147" data-mp="xwa12hisuccm">
                <span className="text-ink-soft" data-id="element-148" data-mp="syql9d6gdrik">Disponibilidad limitada — solo hoy</span>
                <span className="text-accent" data-id="element-149" data-mp="owwt5tabpvu0">68% reservado</span>
              </div>
              <div className="mt-3 h-2 overflow-hidden rounded-full bg-sand" role="progressbar" aria-valuenow={68} aria-valuemin={0} aria-valuemax={100} aria-label="Cupos reservados" data-id="element-150" data-mp="1lmw8c6kzbslk">
                <div className="h-full w-[68%] rounded-full bg-accent" data-id="element-151" data-mp="17n4o3o3vdfz4" />
              </div>
            </div>
          </div>

          <article className="rounded-2xl border border-ink/10 bg-paper p-8 shadow-lift sm:p-10" data-id="element-152" data-mp="17kn32aam3vx">
            <p className="text-[11px] font-semibold uppercase tracking-eyebrow text-ink-mute" data-id="element-153" data-mp="3sbstu274apcq">
              El Profe de Guitarra — El pack completo «Supervivencia del profe»
            </p>
            <h3 className="mt-4 font-display text-3xl font-semibold leading-tight text-ink" data-id="element-154" data-mp="2mn9rqlf9v6p">
              6 volúmenes + 6 bonos gratis
            </h3>

            <h4 className="mt-8 text-[11px] font-semibold uppercase tracking-eyebrow text-accent" data-id="element-155" data-mp="3kvnqzczjtyhi">
              Qué incluye
            </h4>
            <ul className="mt-4 space-y-3" data-id="element-156" data-mp="3b38e2u34003h">
              {offerIncludes.map(item => <li key={item} className="flex items-start gap-3 text-[15px] text-ink" data-id="element-157" data-mp="3fuhz1hdpqf91">
                  <CheckIcon aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-accent" data-id="element-158" data-mp="315u7dm6zmpod" />
                  <span data-id="element-159" data-mp="363vpa3sogiy9">{item}</span>
                </li>)}
            </ul>

            <div className="mt-8 border-t border-line pt-6" data-id="element-160" data-mp="2s4w08v19621k">
              <p className="text-[11px] font-semibold uppercase tracking-eyebrow text-ink-mute" data-id="element-161" data-mp="2s5fi6bqwkqfl">
                Valor real total: $745.000
              </p>
              <div className="mt-3 flex flex-wrap items-baseline gap-4" data-id="element-162" data-mp="2dh5fxx06no09">
                <span className="font-display text-5xl font-semibold leading-none text-ink sm:text-6xl" data-id="element-163" data-mp="28iu81rtg7nko">
                  $27.990
                </span>
                <span className="font-display text-2xl text-ink-mute line-through" data-id="element-164" data-mp="2mk6lnwl4zd3e">$745.000</span>
              </div>
              <p className="mt-4 inline-block rounded-full bg-accent-soft px-3 py-1.5 text-[12px] font-semibold uppercase tracking-wide text-accent-dark" data-id="element-165" data-mp="2ij4k393qyoy9">
                Ahorrás $717.010 — 96% de descuento
              </p>
              <p className="mt-3 text-[11px] font-semibold uppercase tracking-eyebrow text-ink-mute" data-id="element-166" data-mp="366mdf92ntv3c">
                Pago único · Acceso de por vida
              </p>
            </div>

            <div className="mt-8" data-id="element-167" data-mp="319vqc1sftz8f">
              <CtaButton data-id="element-168" data-mp="3f6iyl0pucbtn">Dame el pack completo ahora</CtaButton>
              <p className="mt-3 text-center text-xs text-ink-mute" data-id="element-169" data-mp="3f4y0x288ccrk">
                Protegido por nuestra garantía de 7 días.
              </p>
            </div>

            <ul className="mt-8 grid gap-3 border-t border-line pt-6 text-xs text-ink-mute sm:grid-cols-3" data-id="element-170" data-mp="18iim5cp3htbe">
              <li className="flex items-center gap-2" data-id="element-171" data-mp="1dgacw3e079e0">
                <LockIcon aria-hidden="true" className="h-3.5 w-3.5" data-id="element-172" data-mp="1i8bnlkviws1x" />
                Pago seguro
              </li>
              <li className="flex items-center gap-2" data-id="element-173" data-mp="1m9dnm3x9l84y">
                <MailIcon aria-hidden="true" className="h-3.5 w-3.5" data-id="element-174" data-mp="pk604qd34oye" />
                PDFs a tu email
              </li>
              <li className="flex items-center gap-2" data-id="element-175" data-mp="uir2avbwdiph">
                <CreditCardIcon aria-hidden="true" className="h-3.5 w-3.5" data-id="element-176" data-mp="uld74n7elk40" />
                Tarjeta · Google Pay · Apple Pay
              </li>
            </ul>
          </article>
        </div>
      </div>
    </section>;
}